/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import WmsCollapse from "../../../components/WmsCollapse/WmsCollapse.jsx";
import WmsInput from "../../../components/WmsInput/WmsInput.jsx";
import WmsButton from "../../../components/WmsButton/WmsButton.jsx";
import WmsCheckBox from "../../../components/WmsCheckBox/WmsCheckBox.jsx";
import WmsDropdown from "../../../components/WmsDropdown/WmsDropdown.jsx";
import WmsFile from "../../../components/WmsFile/WmsFile.jsx";
import WmsComboBox from "../../../components/WmsComboBox/WmsComboBox.jsx";

import * as GlobalService from "./../../../global_services";

declare var window: any;

interface Props {
    selector: string;
    connectionSchemaXgroupings: any;
    connectionSchemaProperties: any;
    connectionSchemaRequired: any;
    closeCarrierConnection: () => void;
    selectedCarrier: any;
    currentCarrierImgUrl: any;
    updateDynamicCarrier: (obj: any) => void;
    carrierConnectionBtnLoader: boolean;
    editDynamicCarrierObj: any;
    isEditDynamicCarrier: boolean;
    selectedCustomerName: string;
}

const EditDynamicCarrierFormComponent: React.FC<Props> = (props: Props): any => {
    const [currentCarrierObj, setCurrentCarrierObj] = useState({});
    const connectionSchemaXgroupings = props.connectionSchemaXgroupings;
    const selectOrEnterText = "Select or Enter ";
    const xEnumDescrition = "x-enumDescriptions";
    const xDisabled = "x-disabled";

    const getFieldMaxLength = (inputName: string, inputElement: any) => {
        if (inputName === "apiToken") {
            return 0;
        }
        if (inputElement?.maxLength > 0) {
            return inputElement.maxLength;
        }
        return 255;
    };
    const regExpCustomerName = "{CustomerName}";

    useEffect(() => {
        setCurrentCarrierObj(props.editDynamicCarrierObj);
    }, [props.editDynamicCarrierObj]);

    const handleCarrierObjChange = async (e: any) => {
        let { name, value } = e.target;
        let finalValue = value;
        if (e.target.type === "checkbox") {
            finalValue = e.target.checked;
        }
        await Object.entries(props.connectionSchemaProperties).map(async ([inputName, inputElement], index) => {
            if (inputElement["x-enumDependentField"] === name) {
                let state = GlobalService.GetRegions(value);
                if ($(`#${inputName}`) && $(`#${inputName}`).data("kendoComboBox")) {
                    $(`#${inputName}`).data("kendoComboBox").value("");
                }
                inputElement[`${xEnumDescrition}`] = state;
                return inputElement;
            } else {
                return inputElement;
            }
        });
        setCurrentCarrierObj((prevState) => ({
            ...prevState,
            [name]: finalValue,
        }));
    };

    const handleFileChange = (param_fileobj: any) => {
        setCurrentCarrierObj((prevState) => ({
            ...prevState,
            [param_fileobj.inputName]: param_fileobj.base64Image,
        }));
    };

    const updateDynamicCarrier = () => {
        props.updateDynamicCarrier(currentCarrierObj);
    };

    const getDropdownOptions = (dropdownData: any, baseCall: any) => {
        let dropdownOptions = [];
        for (const dKey in dropdownData) {
            let dataObj: any;
            if (typeof dropdownData[`${dKey}`] === "string") {
                dataObj = {
                    Name: dropdownData[`${dKey}`],
                    NameValue: baseCall === "countryCode" ? dKey.toUpperCase() : dKey,
                };
            } else {
                dataObj = {
                    Name: dropdownData[`${dKey}`].Name,
                    NameValue: dropdownData[`${dKey}`].RegionCode,
                };
            }
            dropdownOptions.push(dataObj);
        }
        return dropdownOptions;
    };

    const isDisabledSaveButton = () => {
        let isDisabled = false;
        for (const key in props.connectionSchemaProperties) {
            if (props.connectionSchemaRequired?.indexOf(key) !== -1 && !currentCarrierObj[`${key}`]) {
                isDisabled = true;
                break;
            }
        }
        return isDisabled;
    };

    return (
        <div>
            <div className="model-content-wrapper dynamic-carrier-wrapper">
                <div className="connection-step-block">
                    <div className={"image-section " + (props.selectedCarrier === "Amazon Buy" ? "img-amazon" : "")}>
                        <img src={props.currentCarrierImgUrl} alt={props.currentCarrierImgUrl} />
                    </div>
                </div>
                <>
                    {/* Check Edit Carrier Properties Available */}
                    {props.isEditDynamicCarrier ? (
                        <>
                            {/* X-Grouping Section */}
                            {connectionSchemaXgroupings.length === undefined ||
                            connectionSchemaXgroupings.length > 0 ? (
                                Object.keys(connectionSchemaXgroupings)
                                    .reverse()
                                    .map((xKey) => (
                                        <WmsCollapse
                                            key={xKey}
                                            id={"DynamicCarrierEditFormScreen" + xKey}
                                            headerLabel={connectionSchemaXgroupings[`${xKey}`].groupTitle}
                                            showCollapseText={false}
                                            showCollapseIcon={false}
                                        >
                                            <div className="account-info-section">
                                                {Object.entries(props.connectionSchemaProperties).map(
                                                    ([inputName, inputElement], index) =>
                                                        inputElement["type"] === "string" &&
                                                        connectionSchemaXgroupings[`${xKey}`].fields?.indexOf(
                                                            inputName
                                                        ) !== -1 ? (
                                                            inputElement["enum"] ? (
                                                                <WmsDropdown
                                                                    id={inputName}
                                                                    key={index}
                                                                    name={inputName}
                                                                    wmsSelector={props.selector + inputName}
                                                                    label={
                                                                        inputElement["x-name"]
                                                                            ? inputElement["x-name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1)
                                                                    }
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    value={currentCarrierObj[`${inputName}`]}
                                                                    options={getDropdownOptions(
                                                                        inputElement[`${xEnumDescrition}`],
                                                                        inputName
                                                                    )}
                                                                    valueField="NameValue"
                                                                    textField="Name"
                                                                    parentClassName="form_group"
                                                                    extraWrapperClass="width-100"
                                                                    blankFirstOption={true}
                                                                    required={
                                                                        props.connectionSchemaRequired?.indexOf(
                                                                            inputName
                                                                        ) !== -1
                                                                    }
                                                                />
                                                            ) : inputElement["x-fileType"] ? (
                                                                <div
                                                                    className="wms-file-component-area"
                                                                    key={"wms-file-component-area" + index}
                                                                >
                                                                    <WmsFile
                                                                        id={inputName}
                                                                        key={index}
                                                                        name={inputName}
                                                                        label={
                                                                            inputElement["x-name"]
                                                                                ? inputElement["x-name"]
                                                                                : inputName.charAt(0).toUpperCase() +
                                                                                  inputName.slice(1)
                                                                        }
                                                                        wmsSelector={props.selector + inputName}
                                                                        fileProcessType="FileSelectReadAsDataUrl"
                                                                        value={""}
                                                                        onChangeFunc={handleFileChange}
                                                                        disabled={false}
                                                                        clearInputOnClick={true}
                                                                        accept={"image/png, image/jpeg"}
                                                                        icon="fa fa-image"
                                                                        maxWidth={240}
                                                                        maxHeight={25}
                                                                    />
                                                                    {currentCarrierObj[`${inputName}`] && (
                                                                        <div className="preview-image">
                                                                            <img
                                                                                key={index}
                                                                                src={currentCarrierObj[`${inputName}`]}
                                                                                alt={
                                                                                    inputElement["x-name"]
                                                                                        ? inputElement["x-name"]
                                                                                        : inputName
                                                                                              .charAt(0)
                                                                                              .toUpperCase() +
                                                                                          inputName.slice(1)
                                                                                }
                                                                                width="50"
                                                                                height="50"
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ) : inputElement[`${xEnumDescrition}`] ? (
                                                                <WmsComboBox
                                                                    id={inputName}
                                                                    key={index}
                                                                    name={inputName}
                                                                    label={
                                                                        inputElement["x-name"]
                                                                            ? inputElement["x-name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1)
                                                                    }
                                                                    wmsSelector={props.selector + inputName}
                                                                    value={currentCarrierObj[`${inputName}`]}
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    options={getDropdownOptions(
                                                                        inputElement[`${xEnumDescrition}`],
                                                                        inputName
                                                                    )}
                                                                    placeholder={
                                                                        selectOrEnterText +
                                                                        (inputElement["x-name"]
                                                                            ? inputElement["x-name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1))
                                                                    }
                                                                    valueField="NameValue"
                                                                    textField="Name"
                                                                    required={
                                                                        props.connectionSchemaRequired?.indexOf(
                                                                            inputName
                                                                        ) !== -1
                                                                    }
                                                                    parentClassName="form_group width-100"
                                                                />
                                                            ) : (
                                                                <WmsInput
                                                                    id={inputName}
                                                                    key={index}
                                                                    inputName={inputName}
                                                                    wmsSelector={props.selector + inputName}
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    label={
                                                                        inputElement["x-name"]
                                                                            ? inputElement["x-name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1)
                                                                    }
                                                                    value={currentCarrierObj[`${inputName}`]}
                                                                    maxLength={getFieldMaxLength(
                                                                        inputName,
                                                                        inputElement
                                                                    )}
                                                                    required={
                                                                        props.connectionSchemaRequired?.indexOf(
                                                                            inputName
                                                                        ) !== -1
                                                                    }
                                                                    disabled={
                                                                        inputElement[`${xDisabled}`]
                                                                            ? inputElement[`${xDisabled}`]
                                                                            : false
                                                                    }
                                                                    extraWrapperClass={"width-100"}
                                                                />
                                                            )
                                                        ) : (
                                                            inputElement["type"] === "boolean" &&
                                                            inputName !== "agreeToCarrierTOS" &&
                                                            connectionSchemaXgroupings[`${xKey}`].fields?.indexOf(
                                                                inputName
                                                            ) !== -1 && (
                                                                <WmsCheckBox
                                                                    id={inputName}
                                                                    key={index}
                                                                    name={inputName}
                                                                    wmsSelector={props.selector + inputName}
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    label={
                                                                        inputElement["x-name"]
                                                                            ? inputElement["x-name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1)
                                                                    }
                                                                    checked={currentCarrierObj[`${inputName}`] === true}
                                                                    isRounded={true}
                                                                    parentClassName={"width-100"}
                                                                />
                                                            )
                                                        )
                                                )}
                                                <WmsCheckBox
                                                    id={"includeShippingCostI"}
                                                    key={"includeShippingCostI"}
                                                    name={"includeShippingCost"}
                                                    wmsSelector={props.selector + "includeShippingCostI"}
                                                    onChangeFunc={handleCarrierObjChange}
                                                    label={window.translate("Label_Include_Shipping_Cost")}
                                                    checked={currentCarrierObj["includeShippingCost"] === true}
                                                    isRounded={true}
                                                    parentClassName={"width-100"}
                                                />
                                                <div className="edit-include-shipping-cost">
                                                    {window
                                                        .translate("Label_Include_Shipping_Cost_Info")
                                                        .replace(regExpCustomerName, props.selectedCustomerName)}
                                                </div>
                                            </div>
                                        </WmsCollapse>
                                    ))
                            ) : (
                                // No X-Grouping Section
                                <WmsCollapse
                                    key={"DynamicCarrierEditFormScreen"}
                                    id={"DynamicCarrierEditFormScreen"}
                                    headerLabel={window.translate("Label_Account_Information")}
                                    showCollapseText={false}
                                    showCollapseIcon={false}
                                >
                                    <div className="account-info-section">
                                        {Object.entries(props.connectionSchemaProperties).map(
                                            ([inputName, inputElement], index) =>
                                                inputElement["type"] === "string" ? (
                                                    inputElement["enum"] ? (
                                                        <WmsDropdown
                                                            id={inputName}
                                                            key={index}
                                                            name={inputName}
                                                            wmsSelector={props.selector + inputName}
                                                            label={
                                                                inputElement["x-name"]
                                                                    ? inputElement["x-name"]
                                                                    : inputName.charAt(0).toUpperCase() +
                                                                      inputName.slice(1)
                                                            }
                                                            onChangeFunc={handleCarrierObjChange}
                                                            value={currentCarrierObj[`${inputName}`]}
                                                            options={getDropdownOptions(
                                                                inputElement[`${xEnumDescrition}`],
                                                                inputName
                                                            )}
                                                            valueField="NameValue"
                                                            textField="Name"
                                                            parentClassName="form_group"
                                                            extraWrapperClass="width-100"
                                                            blankFirstOption={true}
                                                            required={
                                                                props.connectionSchemaRequired?.indexOf(inputName) !==
                                                                -1
                                                            }
                                                        />
                                                    ) : inputElement["x-fileType"] ? (
                                                        <div
                                                            className="wms-file-component-area"
                                                            key={"wms-file-component-area" + index}
                                                        >
                                                            <WmsFile
                                                                id={inputName}
                                                                key={index}
                                                                name={inputName}
                                                                label={
                                                                    inputElement["x-name"]
                                                                        ? inputElement["x-name"]
                                                                        : inputName.charAt(0).toUpperCase() +
                                                                          inputName.slice(1)
                                                                }
                                                                wmsSelector={props.selector + inputName}
                                                                fileProcessType="FileSelectReadAsDataUrl"
                                                                value={""}
                                                                onChangeFunc={handleFileChange}
                                                                disabled={false}
                                                                clearInputOnClick={true}
                                                                accept={"image/png, image/jpeg"}
                                                                icon="fa fa-image"
                                                                maxWidth={240}
                                                                maxHeight={25}
                                                            />
                                                            {currentCarrierObj[`${inputName}`] && (
                                                                <div className="preview-image">
                                                                    <img
                                                                        key={index}
                                                                        src={currentCarrierObj[`${inputName}`]}
                                                                        alt={
                                                                            inputElement["x-name"]
                                                                                ? inputElement["x-name"]
                                                                                : inputName.charAt(0).toUpperCase() +
                                                                                  inputName.slice(1)
                                                                        }
                                                                        width="50"
                                                                        height="50"
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : inputElement[`${xEnumDescrition}`] ? (
                                                        <WmsComboBox
                                                            id={inputName}
                                                            key={index}
                                                            name={inputName}
                                                            label={
                                                                inputElement["x-name"]
                                                                    ? inputElement["x-name"]
                                                                    : inputName.charAt(0).toUpperCase() +
                                                                      inputName.slice(1)
                                                            }
                                                            wmsSelector={props.selector + inputName}
                                                            value={currentCarrierObj[`${inputName}`]}
                                                            onChangeFunc={handleCarrierObjChange}
                                                            options={getDropdownOptions(
                                                                inputElement[`${xEnumDescrition}`],
                                                                inputName
                                                            )}
                                                            placeholder={
                                                                selectOrEnterText +
                                                                (inputElement["x-name"]
                                                                    ? inputElement["x-name"]
                                                                    : inputName.charAt(0).toUpperCase() +
                                                                      inputName.slice(1))
                                                            }
                                                            valueField="NameValue"
                                                            textField="Name"
                                                            required={
                                                                props.connectionSchemaRequired?.indexOf(inputName) !==
                                                                -1
                                                            }
                                                            parentClassName="form_group width-100"
                                                        />
                                                    ) : (
                                                        <WmsInput
                                                            id={inputName}
                                                            key={index}
                                                            inputName={inputName}
                                                            wmsSelector={props.selector + inputName}
                                                            onChangeFunc={handleCarrierObjChange}
                                                            label={
                                                                inputElement["x-name"]
                                                                    ? inputElement["x-name"]
                                                                    : inputName.charAt(0).toUpperCase() +
                                                                      inputName.slice(1)
                                                            }
                                                            value={currentCarrierObj[`${inputName}`]}
                                                            maxLength={getFieldMaxLength(inputName, inputElement)}
                                                            required={
                                                                props.connectionSchemaRequired?.indexOf(inputName) !==
                                                                -1
                                                            }
                                                            extraWrapperClass={"width-100"}
                                                            disabled={
                                                                inputElement[`${xDisabled}`]
                                                                    ? inputElement[`${xDisabled}`]
                                                                    : false
                                                            }
                                                        />
                                                    )
                                                ) : (
                                                    inputElement["type"] === "boolean" &&
                                                    inputName !== "agreeToCarrierTOS" && (
                                                        <WmsCheckBox
                                                            id={inputName}
                                                            key={index}
                                                            name={inputName}
                                                            wmsSelector={props.selector + inputName}
                                                            onChangeFunc={handleCarrierObjChange}
                                                            label={
                                                                inputElement["x-name"]
                                                                    ? inputElement["x-name"]
                                                                    : inputName.charAt(0).toUpperCase() +
                                                                      inputName.slice(1)
                                                            }
                                                            checked={currentCarrierObj[`${inputName}`] === true}
                                                            isRounded={true}
                                                            parentClassName={"width-100"}
                                                        />
                                                    )
                                                )
                                        )}
                                        <WmsCheckBox
                                            id={"includeShippingCostI"}
                                            key={"includeShippingCostI"}
                                            name={"includeShippingCost"}
                                            wmsSelector={props.selector + "includeShippingCostI"}
                                            onChangeFunc={handleCarrierObjChange}
                                            label={window.translate("Label_Include_Shipping_Cost")}
                                            checked={currentCarrierObj["includeShippingCost"] === true}
                                            isRounded={true}
                                            parentClassName={"width-100"}
                                        />
                                        <div className="edit-include-shipping-cost">
                                            {window
                                                .translate("Label_Include_Shipping_Cost_Info")
                                                .replace(regExpCustomerName, props.selectedCustomerName)}
                                        </div>
                                    </div>
                                </WmsCollapse>
                            )}
                        </>
                    ) : (
                        <WmsCollapse
                            key={"DynamicCarrierEditFormScreenI"}
                            id={"DynamicCarrierEditFormScreenI"}
                            headerLabel={window.translate("Label_Account_Information")}
                            showCollapseText={false}
                            showCollapseIcon={false}
                        >
                            <div className="account-info-section">
                                {typeof currentCarrierObj["nickname"] !== "undefined" ? (
                                    <WmsInput
                                        id={"nicknameI"}
                                        inputName={"nickname"}
                                        wmsSelector={props.selector + "nicknameI"}
                                        onChangeFunc={handleCarrierObjChange}
                                        label={window.translate("Label_Nickname")}
                                        value={currentCarrierObj["nickname"]}
                                        extraWrapperClass={"width-100"}
                                    />
                                ) : (
                                    <></>
                                )}
                                <WmsCheckBox
                                    id={"includeShippingCostI"}
                                    key={"includeShippingCostI"}
                                    name={"includeShippingCost"}
                                    wmsSelector={props.selector + "includeShippingCostI"}
                                    onChangeFunc={handleCarrierObjChange}
                                    label={window.translate("Label_Include_Shipping_Cost")}
                                    checked={currentCarrierObj["includeShippingCost"] === true}
                                    isRounded={true}
                                    parentClassName={"width-100"}
                                />
                                <div className="edit-include-shipping-cost">
                                    {window
                                        .translate("Label_Include_Shipping_Cost_Info")
                                        .replace(regExpCustomerName, props.selectedCustomerName)}
                                </div>
                            </div>
                        </WmsCollapse>
                    )}
                </>
            </div>
            <div className="footer-btn-holder">
                <WmsButton
                    label={window.translate("Label_Close")}
                    buttonType="orange"
                    wmsSelector={props.selector + "exitEditDynamicConnection"}
                    onClickFunc={props.closeCarrierConnection}
                    icon="fa-times-circle-o"
                />
                <WmsButton
                    label={window.translate("Label_Save")}
                    wmsSelector={props.selector + "EditDynamicCarriersave"}
                    onClickFunc={updateDynamicCarrier}
                    icon="fa-floppy-o"
                    loading={props.carrierConnectionBtnLoader}
                    disabled={isDisabledSaveButton()}
                />
            </div>
        </div>
    );
};

EditDynamicCarrierFormComponent.propTypes = {};

export default React.memo(EditDynamicCarrierFormComponent);
